import { useEffect } from "react";
import { handleTrackingConsent, setUserIdentity } from "../datadog";
import type { CdcUserAttributes } from "../models/cdcUser";
import type { ColorSearchSettings } from "../models/colors";
import { getDataFromLocalstorageByKey } from "../service/utils/get-data-localstorage";
import { checkInternalUser } from "../service/utils/get-user-type";

export const useDatadogTracking = (
  user: any,
  settings: ColorSearchSettings,
) => {
  useEffect(() => {
    const cdcUser: CdcUserAttributes | undefined =
      getDataFromLocalstorageByKey("cdcUser");
    const isInternalUser = checkInternalUser(user, settings);

    if (cdcUser?.email) {
      handleTrackingConsent(true);
      const userName =
        cdcUser.firstName && cdcUser.lastName
          ? `${cdcUser.firstName} ${cdcUser.lastName}`
          : undefined;
      setUserIdentity(cdcUser.email, "external", userName);
    } else if (user?.email) {
      handleTrackingConsent(true);
      const userName =
        user.given_name && user.family_name
          ? `${user.given_name} ${user.family_name}`
          : undefined;
      setUserIdentity(
        user.email,
        isInternalUser ? "internal" : "external",
        userName,
      );
    }
  }, [user, settings]);

  useEffect(() => {
    const handleUsercentricsConsent = (e: CustomEvent) => {
      if (e.detail?.event !== "consent_status") return;

      const cdcUser: CdcUserAttributes | undefined =
        getDataFromLocalstorageByKey("cdcUser");
      const isLoggedIn = Boolean(cdcUser?.email) || Boolean(user?.email);

      if (!isLoggedIn) {
        handleTrackingConsent(Boolean(e.detail.Datadog));
      }
    };

    window.addEventListener(
      "ucEvent",
      handleUsercentricsConsent as EventListener,
    );
    return () => {
      window.removeEventListener(
        "ucEvent",
        handleUsercentricsConsent as EventListener,
      );
    };
  }, [user, settings]);
};
